import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { media } from 'utils/style';
import XPOBack from 'assets/icons/xpo/arrow-back.svg';

const Back = styled.button`
position:absolute;
z-index:1;
    display: inline-block;
    width: 90px;
    height: 24px;
    padding-right: 6px;
    text-decoration: none;
    color: var(--grey700);
    &:hover {
      opacity: 0.7;
    }
    text-align:left;
    background-image: url(${XPOBack});
    background-color: var(--white);
    background-repeat: no-repeat;
    background-position: 0px 0px;
    border: none;
    cursor: pointer;
    padding-left: 30px; 
    vertical-align: middle;
    margin: 16px;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 18px;
    font-weight: 500;
    ${media.lessThan('small')`
        margin-top: 174px;
    `};
    ${media.lessThan('extraSmall')`
        margin-top: 116px;
    `};
`;

export const BackButton = ({onClick}) => {
    const { t } = useTranslation('Landing');

    return (
      <Back onClick={onClick}>      
       {t('main.back')}
      </Back>
    );
  };

BackButton.propTypes = {
    onClick: PropTypes.func
  };
  
BackButton.defaultProps = {
    onClick: () => ({})
  };
